<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">{{'Cities list' | translate}}</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative" routerLink="/">{{'Dashboard' | translate}}</li>
        <li class="breadcrumb-item position-relative">{{'Cities' | translate}}</li>
    </ol>
</div>

<mat-card class="daxa-card users-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title class="w-full">

            <app-search-input-with-debouncing (searchEvent)="onSearch($event)" [placeholder]="'Search cities' | translate">
            </app-search-input-with-debouncing>
            <button mat-raised-button color="primary" (click)="openAddCity()">
                <mat-icon class="mr-1">add</mat-icon>
                {{"Add new city" | translate}}
            </button>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="users-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>

                    <!-- ID -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Id' | translate}}</th>
                        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
                    </ng-container>

                    <!-- City Title -->
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'City_name' | translate}}</th>
                        <td mat-cell *matCellDef="let row">{{ row.title }}</td>
                    </ng-container>

                    <!-- Latitude -->
                    <ng-container matColumnDef="latitude">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Latitude' | translate}}</th>
                        <td mat-cell *matCellDef="let row">
                            <span
                                class="coordinate-chip"
                                [class.coordinate-chip--empty]="row.latitude === null"
                                [matTooltip]="row.latitude !== null ? (('Latitude' | translate) + ': ' + row.latitude) : ''">
                                <mat-icon aria-hidden="true">north</mat-icon>
                                {{ coordinateLabel(row.latitude, 'lat') }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Longitude -->
                    <ng-container matColumnDef="longitude">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Longitude' | translate}}</th>
                        <td mat-cell *matCellDef="let row">
                            <span
                                class="coordinate-chip"
                                [class.coordinate-chip--empty]="row.longitude === null"
                                [matTooltip]="row.longitude !== null ? (('Longitude' | translate) + ': ' + row.longitude) : ''">
                                <mat-icon aria-hidden="true">east</mat-icon>
                                {{ coordinateLabel(row.longitude, 'lng') }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Time Zone -->
                    <ng-container matColumnDef="timeZoneId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Time_zone' | translate}}</th>
                        <td mat-cell *matCellDef="let row">
                            <span class="timezone-cell" [matTooltip]="row.timeZoneId">
                                <mat-icon aria-hidden="true">schedule</mat-icon>
                                {{ row.timeZoneId }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Disabled -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Status' | translate}}</th>
                        <td mat-cell *matCellDef="let row">
                            <span class="status-chip" [class.active]="!row.disabled" [class.inactive]="row.disabled">
                                <mat-icon>{{ row.disabled ? 'cancel' : 'check_circle' }}</mat-icon>
                                {{ (row.disabled ? 'Inactive' : 'Active') | translate }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- CreatedAt -->
                    <ng-container matColumnDef="CreatedAt">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Created_At' | translate}}</th>
                        <td mat-cell *matCellDef="let row">{{ row.CreatedAt | timestampDate:dateLocale:undefined:{
                            dateStyle:'medium', timeStyle:'short' } }}</td>
                    </ng-container>

                    <!-- lastUpdate -->
                    <ng-container matColumnDef="lastUpdate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'Last_update' | translate}}</th>
                        <td mat-cell *matCellDef="let row">{{ row.lastUpdate | timestampDate:dateLocale:undefined:{
                            dateStyle:'medium', timeStyle:'short' } }}</td>
                    </ng-container>

                    <!-- Action -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>{{ 'Action' | translate }}</th>
                        <td mat-cell *matCellDef="let row">
                            <div class="action-info text-center">
                                <button mat-button class="daxa" matTooltip="{{'Edit' | translate}}" (click)="onEdit(row.id)">
                                    <i class="material-symbols-outlined">edit</i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Header / Rows -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                    <!-- Empty / Loading Row -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                            <ng-container *ngIf="loading; else noDataTpl">
                                <div class="flex items-center justify-center p-4">
                                    <mat-spinner diameter="32"></mat-spinner>
                                </div>
                            </ng-container>
                            <ng-template #noDataTpl>{{ 'No data found' | translate }}</ng-template>
                        </td>
                    </tr>
                </table>
            </div>

            <mat-paginator [pageSizeOptions]="[8, 16, 32]" [pageSize]="pageSize" showFirstLastButtons>
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>